<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">
    <!-- <H3 style="text-align:center">
        <span v-if="dataForm.id">{{dataForm.projectName}}</span>
        <el-input v-else v-model="dataForm.projectName" size="small"></el-input>
    </H3> -->

    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="factoryCode">
                        <span v-if="viewFlag === 'view'">{{dataForm.factoryCode}}</span>
                        <el-select v-else v-model="dataForm.factoryCode" filterable placeholder="请选择工厂">
                            <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料编码:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="materialCode">
                        <span v-if="viewFlag === 'view'">{{dataForm.materialCode}}</span>
                        <el-input v-else v-model="dataForm.materialCode" placeholder="物料编码" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="基本计量单位:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="basicUnit">
                        <span v-if="viewFlag === 'view'">{{dataForm.basicUnit}}</span>
                        <el-select v-else v-model="dataForm.basicUnit" filterable placeholder="基本计量单位">
                            <el-option v-for="item in unitList" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="辅助单位:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="auxiliaryUnit">
                        <span v-if="viewFlag === 'view'">{{dataForm.auxiliaryUnit}}</span>
                        <el-select v-else v-model="dataForm.auxiliaryUnit" filterable placeholder="辅助单位">
                            <el-option v-for="item in unitList" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="转换分子:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="numerator" size="small">
                        <span v-if="viewFlag === 'view'">{{dataForm.numerator}}</span>
                        <el-input-number v-else v-model="dataForm.numerator" :min="1" :max="999" style="width:200px" label="转换分子"></el-input-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="转换分母:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="denominator" size="small">
                        <span v-if="viewFlag === 'view'">{{dataForm.denominator}}</span>
                        <el-input-number v-else v-model="dataForm.denominator" :min="1" :max="999" style="width:200px" label="转换分母"></el-input-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料中文描述:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="materialName" size="small">
                        <span v-if="viewFlag === 'view'">{{dataForm.materialName}}</span>
                        <el-input v-else v-model="dataForm.materialName" placeholder="物料中文描述"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料组:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="materialGroup" size="small">
                        <span v-if="viewFlag === 'view'">{{dataForm.materialGroup}}</span>
                        <el-input v-else v-model="dataForm.materialGroup" placeholder="物料组"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料组描述:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="materialGroupName" size="small">
                        <span v-if="viewFlag === 'view'">{{dataForm.materialGroupName}}</span>
                        <el-input v-else v-model="dataForm.materialGroupName" placeholder="物料组描述"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item></el-descriptions-item>
            </el-descriptions>
        </div>
        <el-row :gutter="40">
            <el-col :span="24" style="text-align:right;">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <el-button v-if="viewFlag !== 'view'" size="small" type="primary" @click="dataFormSubmit()">
                    保存
                </el-button>
                <el-button v-if="viewFlag !== 'view'" size="small" type="success" @click="dataFormPublish()">
                    发布
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</el-dialog>
</template>

<script>
import {
    createPart,
    editPart,
    queryById,
} from '@/controller/mdata'
import {
    getFactoryList,
    getUnitList
} from '@/controller/systemData'
import moment from 'moment'
// require('@/mock/mockProject');

export default {
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            dimensionList: [],
            rateList: [],
            disabled_flag: true,
            viewFlag: '',
            factoryList: [],
            unitList: [],
            dataForm: {
                factoryCode: '',
                materialCode: '',
                basicUnit: '',
                auxiliaryUnit: '',
                numerator: '',
                denominator: '',
                materialName: '',
                materialGroup: '',
                materialGroupName: ''
            },
            dataRule: {
                // projectManagerId: [{
                //     required: true,
                //     message: '项目负责人名称不能为空',
                //     // trigger: 'blur'
                // }],
                // code: [{
                //     required: true,
                //     message: '组织代码不能为空',
                //     trigger: 'blur'
                // }],
                // tenantName: [{
                //     required: true,
                //     message: '请先在页面顶部导航栏选择租户',
                //     trigger: 'blur'
                // }]
            }
        }
    },
    components: {},
    mounted() {},
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("yyyy-MM-DD")
        },
        init(data, id, viewFlag) {
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.dimensionList = [];
            this.rateList = [];
            this.viewData.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    queryById({}, this.dataForm.id).then(data => {
                        if (data && data.code === '00') {
                            this.dataForm = data.body;
                        }
                    });
                }
                this.getFactoryList()
                this.getUnitList()
            })
        },
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        getUnitList() {
            getUnitList({
                code: '',
                name: ''
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            })
        },
        dataFormPublish() {
            this.dataForm.partStatus = '1'
            this.dataFormSubmit()
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                let params = this.dataForm
                if (valid) {
                    // debugger
                    if (this.dataForm.id) {
                        editPart(params).then(data => {
                            if (data && data.code === '00') {
                                // this.dataForm = data.body;
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createPart(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.id = data.body ? data.body.id : '';
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })

                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 435.5px;'
        }
    },
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

form.el-form.org-dialog-form {
    width: 100%;
}

.linetext {
    white-space: pre-line;
}

.el-tabs__item {
    user-select: none;
}

.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}

.mb15 {
    margin-bottom: 15px;
}

.el-form-item__error {
    padding-top: 0;
}
</style>
